module.exports = __webpack_public_path__ + "static/media/tinywow_2435AmbrosiapollenaufNarbe_colored_55475512.afa6a895.jpg";